import React from 'react'

export default function ScreenshotWarningModal() {
    return (
        <>
            <div className="screenshot-warning__container warning">Please record or screenshot your Report Number and PIN for future reference</div>
        </>
    )
}